import React, { Component } from 'react'
import { connect } from 'react-redux'

import { logged, notLoggedIn } from '../../store/actions/user'
import { openModal, closeModal } from '../../store/actions/Modais'

import Helmet from 'react-helmet'
import Topbar from '../../SPRINTA/Topbar'
import Footer from '../../SPRINTA/Footer'
import T from '../../SPRINTA/translate/T'

class Template extends Component {

    constructor(props) {
        super(props)
        T.handleUpdate(() => {
            this.forceUpdate()
        })
    }

   handleLogin(response) {
      if(response.status === 'loading') return

      if(response.logged)
           this.props.logged(response.data)
      else
           this.props.notLoggedIn()
   }


    render() {
        return (
            <div>
                <Topbar
                    language={T.getLanguage()}
                    isLogged={this.props.userData ? true : false}
                    handleLogin={ response => this.handleLogin( response ) }
                    modalOpened={ this.props.modais.modalOpened }
                    handleModalClose={ (ref) => { this.props.closeModal(ref) } }
                />

                <Helmet>
                    <title>SPRINTA</title>
                    <meta property="og:locale" content="pt_BR"/>
                    <meta property="og:url" content={`www.sprinta.com.br`}/>
                    <meta property="og:title" content={`SPRINTA | Loucos por esportes`}/>
                </Helmet>

                { this.props.children }

                <Footer
                    lang={T.getLanguage()}
                    handleLangChanged={lang => T.setLanguage(lang)}
                />
            </div>
        )
    }
}


const mapStateToProps = store => ({
    user: store.user,
    modais: store.modaisReducer
})

const mapDispatchToProps= {
    logged,
    notLoggedIn,
    openModal,
    closeModal,
}

export default connect( mapStateToProps, mapDispatchToProps )(Template)



// WEBPACK FOOTER //
// ./src/App/Template/index.js